import * as React from "react";
import type { SVGProps } from "react";
const SvgSlashForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6.909 20.818 17.09 3.182"
    />
  </svg>
);
export default SvgSlashForward;
